import * as Yup from "yup";

const customerSchema = {};

customerSchema.validateCompanyAdd = () => {
  return Yup.object({
    customer_name: Yup.string()
      .trim()
      .required("Customer name is required.")
      .min(3, "Customer name minimum length is 3")
      .max(45, "Customer name should be at most 45 characters."),
      // .matches(/^[aA-z0-9Z-\s]+$/, `Customer name should be Alphanumeric only`),
    customer_mobile: Yup.string()
      .min(9, "Customer Mobile No length must be 9 to 13 digits")
      .max(15, "Customer Mobile No length must be 9 to 13 digits"),
    // cust_address: Yup.string(),
    // cust_state_id: Yup.string().required('State is required.'),
    // cust_city_id: Yup.string().required('City is required.'),
    // cust_pincode: Yup.string()
    // .required('Pincode is required.')
    // .max(9, 'Pincode symbol should be at most 9 characters.')
    // .min(5,'Pincode symbol should be at most 5 characters.')
    // .matches(/^[0-9\s]+$/, `Pincode name should be number`),
  });
};

customerSchema.validateCompanyEdit = () => {
  return Yup.object({
    customer_name: Yup.string()
      .trim()
      .required("Customer name is required.")
      .min(3, "Customer name minimum length is 3")
      .max(100, "Customer name should be at most 100 characters."),
      // .matches(/^[aA-z0-9Z-\s]+$/, `Customer name should be Alphanumeric only`),
    // customer_mobile: Yup.string()
    // .required('Mobile no is required.')
    // .min(9, 'Mobile no should be at least 9 characters.')
    // .max(13, 'Mobile no should be at most 12 characters.'),
    customer_mobile: Yup.string()
      .nullable()
      .transform((v, o) => (o === "" ? null : v))
      .min(9, "Customer Mobile No length must be 9 to 13 digits")
      .max(15, "Customer Mobile No length must be 9 to 13 digits"),
    // cust_address: Yup.string(),
    // cust_state_id: Yup.string().required('State is required.'),
    // cust_city_id: Yup.string().required('City is required.'),
    // cust_pincode: Yup.string()
    // .required('Pincode is required.')
    // .max(9, 'Pincode symbol should be at most 9 characters.')
    // .min(5,'Pincode symbol should be at most 5 characters.')
    // .matches(/^[0-9\s]+$/, `Pincode name should be number`),
  });
};

export default customerSchema;
